import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, WritableSignal, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ProgressbarComponent } from '@shared/components/progressbar/progressbar.component';
import { CommentsModalComponent } from '../comments-modal/comments-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { ModalService } from '@shared/services/modal.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export enum hotelReviewLabels {
 CleanlinessReview = 'پاکیزگی هتل ها و اتاق ها',
 ComfortReview = 'آرامش و رحتی',
 StaffReview = 'عملکرد کارکنان',
 FoodReview = 'کیفیت غذا',
 FacilitiesReview = 'امکانات',
 ValueForMoneyReview = 'ارزش هتل نسبت به قیمت',
 LocationReview = 'موقعیت و دسترسی',
}

@Component({
 selector: 'iho-pdp-comments-popup',
 standalone: true,
 imports: [CommonModule, ProgressbarComponent],
 templateUrl: './pdp-comments-popup.component.html',
 styleUrls: ['./pdp-comments-popup.component.scss'],
})
export class PdpCommentsPopupComponent implements OnInit {
 router = inject(Router);
 dialog = inject(MatDialog);

 hotelUiService = inject(HotelInfoUiService);
 hotelInfoSummary: any;

 totalComments!: number;

 reviewLabels: WritableSignal<Partial<any> | []> = signal([]);

 hotelReviewLabels: any = [
  {
   en: 'CleanlinessReview',
   fa: 'پاکیزگی هتل ها و اتاق ها',
  },
  {
   en: 'ComfortReview',
   fa: 'آرامش و راحتی',
  },
  {
   en: 'StaffReview',
   fa: 'عملکرد کارکنان',
  },
  {
   en: 'FoodReview',
   fa: 'کیفیت غذا',
  },
  {
   en: 'FacilitiesReview',
   fa: 'امکانات',
  },
  {
   en: 'LocationReview',
   fa: 'موقعیت و دسترسی',
  },
  {
   en: 'ValueForMoneyReview',
   fa: 'ارزش هتل نسبت به قیمت',
  },
 ];

 ecolodgeReviewLabels: any = [
  {
   en: 'CleanlinessReview',
   fa: 'پاکیزگی اقامتگاه ها و اتاق ها',
  },
  {
   en: 'ComfortReview',
   fa: 'آرامش و راحتی',
  },
  {
   en: 'StaffReview',
   fa: 'عملکرد کارکنان',
  },
  {
   en: 'FoodReview',
   fa: 'کیفیت غذا',
  },
  {
   en: 'FacilitiesReview',
   fa: 'امکانات',
  },
  {
   en: 'LocationReview',
   fa: 'موقعیت و دسترسی',
  },
  {
   en: 'ValueForMoneyReview',
   fa: 'ارزش اقامتگاه نسبت به قیمت',
  },
 ];

 ngOnInit(): void {
  this.hotelInfoSummary = this.hotelUiService.hotelInfo();

  this.hotelReviewData.set(this.hotelInfoSummary?.LabelHotelReview);
  this.totalComments = this.hotelInfoSummary?.LabelHotelReview?.TotalReview;

  const filteredData = Object.keys(hotelReviewLabels).reduce((acc, key) => {
   const enumKey = this.hotelReviewLabels[key as keyof typeof hotelReviewLabels];
   // acc[enumKey] = this.mockdata[enumKey];
   return acc;
  }, {} as { [key in hotelReviewLabels]: number });
 }

 modalService = inject(ModalService);
 destroyRef = inject(DestroyRef);

 hotelReviewData: WritableSignal<{ name: string; score: number | string }[]> = signal([]);

 showModalComments(e: Event) {
  e.stopPropagation();
  const dialogRef = this.dialog.open(CommentsModalComponent, {
   panelClass: [
    'custom-modal',
    'comments-modal',
    'w-screen',
    'lg:w-[80%]',
    'h-screen',
    '!max-w-full',
    'lg:h-[88vh]',
    'lg:min-h-[700px]',
   ],
   data: {
    dataSource: this.hotelReviewData(),
    HotelHeader: this.hotelInfoSummary.HotelHeader,
    hid: this.hotelInfoSummary.HotelId,
    type: this.hotelInfoSummary.Type,
    HouseId: this.hotelInfoSummary.HouseId,
   },
   autoFocus: false,
  });
  // Handle the result or any other actions as needed
  dialogRef.afterClosed().subscribe((result) => {
   this.modalService.isAnyModalOpen.set(false);
  });

  dialogRef
   .afterOpened()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe(() => {
    this.modalService.isAnyModalOpen.set(true);
   });
 }
}
